var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-block btn-auth-login",attrs:{"href":_vm.oauthPath,"id":"googleRegisterLink"}},[_c('img',{staticClass:"icon-google",attrs:{"alt":"google","src":"/img/icon/google.png"}}),_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }